import { PERMISSION } from "@/hooks/useCapabilities";
import type { FlagRecord } from "@/hooks/useFeatureFlags";
import type { Capability } from "@/providers/AuthorizationProvider";
import { canShowCommissionPlatformChrome } from "./commission/_utils";

export const GRP_FINANCE_PERMISSIONS = [
  PERMISSION.viewGrpEnrollments,
  PERMISSION.viewMemberContributions,
  PERMISSION.viewSponsorContributions
] as const;

export const canViewGrpFinance = (capabilities: Capability): boolean =>
  GRP_FINANCE_PERMISSIONS.some((permission) => capabilities.permissions.includes(permission));

export const canShowGrpFinanceChrome = (flags: FlagRecord, capabilities: Capability): boolean =>
  !!flags["backoffice-grp"] && canViewGrpFinance(capabilities);

export { canShowCommissionPlatformChrome, canViewCommissionPlatform } from "./commission/_utils";

export const canViewFinance = (flags: FlagRecord, capabilities: Capability): boolean =>
  canShowGrpFinanceChrome(flags, capabilities) || canShowCommissionPlatformChrome(flags, capabilities);
